// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__SfISU","fadeIn":"Notification_fadeIn__wmsY7","progress":"Notification_progress__i+J2i","progressOut":"Notification_progressOut__lYgb9"};